<template>
  <div class="c-menuDashboard m-menuSlideout m-menuSlideout--left "
  id="menu"
      :class="{
          'c-menuDashboard--fixed': (!isPageAtBottom && !isPageAtTop) || isMobile,
          'c-menuDashboard--inFooter': isPageAtBottom
      }"
  >
    <div class="m-menuSlideout_wrapper">
      <header class="m-menuSlideout_header m-menuSlideout_header--clean s-paddingLeft-sm s-marginTop-mdl">
        <h2 class="c-menuDashboard_title s-marginBottom-sm">MINHAS COTAÇÕES</h2>
        <img class="c-menuDashboard_close m-menuSlideout_close" :src="require('icon/custom/modal-close.svg')" alt="fechar" title="fechar" @click="$emit('close')">
      </header>

        <div class="m-menuSlideout_userDashboard m-menuSlideout_userDashboard--clean">
          <div class="m-menuList m-menuList--borderless m-menuList--clean">
            <a class="m-menuList_link m-menuList_link--clean" :href="quoteRequest.index">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1169_2817)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M14.375 10.625a1.25 1.25 0 00-1.25-1.25h-7.5l-.883-.884a1.25 1.25 0 00-.885-.366H1.875a1.25 1.25 0 00-1.25 1.25v8.75a1.25 1.25 0 001.25 1.25h11.25a1.25 1.25 0 001.25-1.25v-7.5z"/><path d="M16.875 14.375v-7.5a1.25 1.25 0 00-1.25-1.25h-7.5l-.883-.884a1.25 1.25 0 00-.885-.366H4.375a1.25 1.25 0 00-1.25 1.25"/><path d="M19.375 10.625v-7.5a1.25 1.25 0 00-1.25-1.25h-7.5L9.742.991a1.25 1.25 0 00-.885-.366H6.875a1.25 1.25 0 00-1.25 1.25"/></g><defs><clipPath id="clip0_1169_2817"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
              <span class="m-menuList_text m-menuList_text--light">Todas as cotações</span>
            </a>
            <a class="m-menuList_link m-menuList_link--clean" :href="quoteRequest.recentActivity">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1712_2020)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M13.65 11.458a5.417 5.417 0 100-10.833 5.417 5.417 0 000 10.833z"/><path d="M13.65 4.475v1.867l1.733 1.733M.933 11.875v7.5M.933 18.125h13.759a2.5 2.5 0 00-2.5-2.5H9.067a2.5 2.5 0 00-2.5-2.5H.933M5.933 15.625h3.134"/></g><defs><clipPath id="clip0_1712_2020"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
              <span class="m-menuList_text m-menuList_text--light">Atividades recentes</span>
            </a>
            <a class="m-menuList_link m-menuList_link--clean" :href="quoteRequest.lastQuotations">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1712_2033)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M6.875 15.625H2.039M16.875 6.875v-2.5a1.25 1.25 0 00-1.25-1.25h-8.75v-1.25a1.25 1.25 0 00-1.25-1.25h-3.75a1.25 1.25 0 00-1.25 1.25v12.333a1.417 1.417 0 002.78.365l1.96-6.795a1.25 1.25 0 011.2-.903h11.56a1.25 1.25 0 011.208 1.572M15.625 11.875h-1.694a1.118 1.118 0 00-.417 2.156l1.72.688a1.118 1.118 0 01-.416 2.156h-1.693M14.375 11.863v-.613M14.375 17.5v-.637"/><path d="M9.375 14.375a5 5 0 1010 0 5 5 0 00-10 0z"/></g><defs><clipPath id="clip0_1712_2033"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
              <span class="m-menuList_text m-menuList_text--light">Últimos orçamentos</span>
            </a>
            <a class="m-menuList_link m-menuList_link--clean" :href="quoteRequest.LastMessages">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1712_2045)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M9.375 15.625a1.25 1.25 0 01-1.25-1.25v-6.25a1.25 1.25 0 011.25-1.25h8.75a1.25 1.25 0 011.25 1.25v6.25a1.25 1.25 0 01-1.25 1.25h-1.25v3.75l-3.75-3.75h-3.75z"/><path d="M5.625 10.625l-2.5 2.5v-3.75h-1.25a1.25 1.25 0 01-1.25-1.25v-6.25a1.25 1.25 0 011.25-1.25h8.75a1.25 1.25 0 011.25 1.25v2.5"/></g><defs><clipPath id="clip0_1712_2045"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
              <span class="m-menuList_text m-menuList_text--light">Últimas mensagens</span>
            </a>
            <a class="m-menuList_link m-menuList_link--clean" :href="quoteRequest.evaluateSuppliers">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1712_2051)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M15.688 10.312l1.042 1.876h2.067a.567.567 0 01.408.97l-1.898 2.071 1.051 2.417a.573.573 0 01-.816.716L15 16.933l-2.542 1.43a.573.573 0 01-.816-.717l1.016-2.333M4.313 10.312L3.27 12.188H1.203a.567.567 0 00-.408.97l1.898 2.071-1.051 2.417a.574.574 0 00.816.716L5 16.933l2.542 1.43a.574.574 0 00.816-.717l-1.016-2.333M10.307 1.784l1.657 3.314 3.19.32a.404.404 0 01.244.687l-2.626 2.627.973 3.569a.404.404 0 01-.57.466l-3.23-1.614-3.228 1.614a.403.403 0 01-.57-.466l.974-3.57-2.627-2.626a.404.404 0 01.245-.688l3.188-.32 1.656-3.313a.403.403 0 01.724 0z"/></g><defs><clipPath id="clip0_1712_2051"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
              <span class="m-menuList_text m-menuList_text--light">Avaliar fornecedores</span>
            </a>
            <a class="m-menuList_link m-menuList_link--clean m-menuList_link--withBadge" :href="quoteRequest.archivedQuotes">
              <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.311.51C.72.56.195 1.037.046 1.661.001 1.851 0 1.88 0 3.06c0 1.078 0 1.134.02 1.202.05.174.188.32.346.365.057.016.778.018 7.134.018s7.077-.002 7.134-.018a.535.535 0 00.346-.365c.02-.068.02-.124.02-1.202 0-1.18-.001-1.208-.046-1.398a1.569 1.569 0 00-.749-.994A1.305 1.305 0 0013.67.51C13.512.496 1.47.497 1.311.51zm.055 1.09a.433.433 0 00-.299.212c-.07.12-.069.102-.069.964v.78h13.004v-.78c0-.862 0-.844-.07-.964a.427.427 0 00-.308-.213c-.092-.015-12.166-.014-12.258 0zm-.049 4.345a.533.533 0 00-.366.38c-.016.068-.017.33-.014 3.49l.004 3.415.024.133c.076.43.218.784.451 1.123.098.143.314.378.444.484.337.275.701.44 1.12.51.12.019.342.02 4.515.02 4.659 0 4.428.003 4.69-.054.24-.051.544-.184.764-.333.304-.205.586-.513.769-.841.158-.284.256-.565.317-.909l.024-.133.004-3.416c.004-3.817.01-3.49-.071-3.628-.175-.294-.545-.341-.77-.098a.618.618 0 00-.136.23c-.011.037-.015.655-.02 3.433-.005 3.21-.006 3.391-.024 3.474a1.663 1.663 0 01-.194.503 1.377 1.377 0 01-.907.662c-.085.02-.347.02-4.33.024-2.905.003-4.285 0-4.387-.008a1.285 1.285 0 01-.907-.451 1.574 1.574 0 01-.359-.73c-.018-.083-.019-.264-.024-3.474-.005-2.778-.009-3.396-.02-3.434A.62.62 0 001.674 6a.474.474 0 00-.357-.054zm4.807.332c-.684.052-1.16.542-1.28 1.316-.021.137-.023.176-.018.657.005.564.01.607.083.837.174.542.636.912 1.223.976.085.01.513.012 1.469.01l1.35-.004.116-.027c.61-.14 1.013-.64 1.1-1.363.008-.072.01-.257.007-.602-.004-.456-.006-.507-.027-.61a1.626 1.626 0 00-.257-.61c-.234-.33-.618-.54-1.06-.58a92.187 92.187 0 00-2.706 0zm.05 1.09c-.145.018-.227.074-.282.195-.067.146-.072.198-.068.673.003.41.004.423.028.49.042.116.124.186.275.235.056.019.167.02 1.357.024.893.002 1.318 0 1.365-.01.177-.031.262-.128.313-.354.016-.071.017-.135.014-.509-.003-.417-.004-.43-.028-.495-.043-.117-.12-.181-.284-.235-.058-.02-.15-.021-1.337-.023a50.43 50.43 0 00-1.353.008z" fill="#fff"/></svg>
              <span class="m-menuList_text m-menuList_text--light">Cotações arquivadas</span>
              <span class="c-badgeLabel c-badgeLabel--new">Novo!</span>
            </a>
          </div>

          <div class="c-menuDashboard_buttonWrap">
            <div class="m-menuList m-menuList--borderless m-menuList--clean">
              <a class="m-menuList_link m-menuList_link--clean" :href="suportLink">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'m-menuList_icon m-menuList_icon--outline'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g clip-path="url(#clip0_1169_2867)" stroke="#D3EBE8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M3.75 15h-.625a2.5 2.5 0 01-2.5-2.5V10a2.5 2.5 0 012.5-2.5h.625a.625.625 0 01.625.625v6.25A.625.625 0 013.75 15zM16.875 15h-.625a.624.624 0 01-.625-.625v-6.25a.625.625 0 01.625-.625h.625a2.5 2.5 0 012.5 2.5v2.5a2.5 2.5 0 01-2.5 2.5zM3.125 7.5A6.875 6.875 0 0110 .625v0A6.875 6.875 0 0116.875 7.5"/><path d="M12.5 18.125h1.875a2.5 2.5 0 002.5-2.5V15"/><path d="M11.25 19.375H10a1.25 1.25 0 010-2.5h1.25a1.25 1.25 0 010 2.5z"/></g><defs><clipPath id="clip0_1169_2867"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
                <span class="m-menuList_text m-menuList_text--light">Precisa de ajuda?</span>
              </a>
            </div>
            <a class="c-menuDashboard_buttonLegacy" :href="quoteRequest.legacy">
              Ver versão antiga
            </a>
          </div>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropOptions } from 'vue'
import { mapState, mapActions } from 'vuex'
import { StoreState } from 'Types'
import  { scroll } from 'Directives/scrollDirective'
import { quoteRequest } from 'routes'
const scrollLock = () => import('Components/scrollLock')
import { landing } from 'routes'

const initialState = () => ({
  suportLink: landing.support,
  isPageAtTop: true,
  isPageAtBottom: false,
  quoteRequest,
  isMobile: false
})

export default Vue.extend({
  data() {
    return initialState()
  },

  components: {
    scrollLock,
  },

  created() {
     this.isMobile = window.matchMedia('(max-width: 1024px)').matches
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },

  computed: {
    ...mapState({})
  },

  methods: {
    handleScroll() {
      var footer = document.querySelector(".c-footer");

      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - footer.clientHeight) {
        this.isPageAtBottom = true
      } else {
        this.isPageAtBottom = false
      }

      if (window.scrollY <= 50) {
        this.isPageAtTop = true;
      } else {
        this.isPageAtTop = false;
      }
    }
  }
})
</script>

<style lang="scss">
@import "~css/_references";
@import "~css/Modules/button";

.c-menuDashboard {
  background-color: $v-colorGreen-dark;
  position: relative;
  height: calc(100vh -  70px);
  width: 280px;
  z-index: 1;

  &--inFooter {
    position: sticky;
  }

  &--fixed {
    position: fixed !important;
    top: 0;
    height: calc(100vh);
  }

  &_title {
    @include f-fontBrand (16px, $v-colorWhite);
    font-weight: 600;
  }

  &_buttonWrap {
    margin-bottom: $v-gap-sm;
    display: flex;
    flex-direction: column;
  }

  &_close {
    display: none;
  }

  &_buttonLegacy {
    @extend .m-button;
    @extend .m-button--success;
    border: 2px solid #43BFB3;
    max-width: 150px;
    background-color: $v-colorGreen-dark;
    font-size: 14px;
    align-self: center;
  }

  @include f-media('<=tablet') {
    position: relative;
    height: 100vh;
    &_close {
      display: block;
    }
  }

  .m-menuList_link--withBadge {
    position: relative;

    .c-badgeLabel {
      box-sizing: border-box;
      display: block;
      padding: 4px 7px;
      margin: $v-gap-xxs / 2;
      font-size: 13px;
      border-radius: 3px;

      &--new {
        position: absolute;
        right: 10px;
        z-index: 2;
        pointer-events: none;
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        border-radius: 20px;
        background-color: $v-colorYellow-3;
        color: $v-colorGray-dark-6;
        box-shadow: 0 2px 3px #00000029;
        border: 1px solid rgba(0,0,0,0.06);
      }
    }
  }
}
</style>
